module.exports = __webpack_public_path__ + "img/es.d8cdd173.jpg";